import React from 'react';
import clsx from 'clsx';
import { renderBlock } from '@/app/index';
import type { IProps } from './SingleColumnLayout.interface';
import './SingleColumnLayout.styles.css';

/**
 * SingleColumnLayout component renders an array of blocks in a single column.
 * It utilizes the BlockWrapper for consistent layout and styling.
 */
export const SingleColumnLayout: React.FC<IProps> = ({
    items,
    className,
    // ...blockWrapperProps // blockWrapperProps are not used directly by this layout but passed to BlockWrapper if it were used.
    // Since this is a layout itself, it might not use BlockWrapper directly.
    // The PRD implies this IS a layout, not a block that USES BlockWrapper.
    // For now, assuming it's a self-contained layout structure.
    // If it needs to be a *block* that *uses* BlockWrapper, this implementation will need adjustment.
}) => {
    return (
        <div className={clsx('singleColumnLayout', className)}>
            <React.Fragment>
                {items?.map((block, index) => renderBlock(block, index))}
            </React.Fragment>
        </div>
    );
};
